/** Embedded entry fields shared via a named GraphQL fragment to stay under 8KB. */
const RICH_TEXT_EMBEDDED_ENTRY_FIELDS = `
  ... on WwwTables {
    name
    content
    tableVariant
    caption { json }
  }
  ... on WwwGallery {
    imagesCollection(limit: 20) {
      items {
        sys { id }
        url
        title
        width
        height
        contentType
        description
      }
    }
  }
  ... on WwwIFrames {
    iframeHtml: content
    name
    variant
  }
  ... on WwwFloatedImageText {
    name
    imageDirection
    imageLink
    image {
      sys { id }
      url
      title
      width
      height
      contentType
      description
    }
    floatedContent: content { json }
  }
  ... on WwwDebtConsolidationCards {
    title
    buttonLink
    buttonText
    options
    image {
      sys { id }
      url
      title
      width
      height
      contentType
      description
    }
  }
  ... on VideoItem {
    name
    url
    aspectRatio
    autoplay
    description
    thumbnailImage {
      sys { id }
      url
      title
      width
      height
      contentType
      description
    }
  }
  ... on WwwCalloutBox {
    name
    type
    calloutTitle: title { json }
    calloutBody: body { json }
    link
    linkText
  }
`

/** Named fragment for rich text `links.entries.block`. Must be appended to the query. */
export const RICH_TEXT_EMBEDDED_ENTRY_FRAGMENT = `
  fragment RichTextEmbeddedEntry on Entry {
    __typename
    sys { id }
    ${RICH_TEXT_EMBEDDED_ENTRY_FIELDS}
  }
`

/** Rich text fields for data strip sections (tables + assets only — keeps page query under 8KB). */
export const DATA_STRIP_CONTENT_FIELDS = `
  json
  links {
    entries {
      block {
        __typename
        sys { id }
        ... on WwwTables {
          name
          content
          tableVariant
          caption { json }
        }
      }
    }
    assets {
      block {
        sys { id }
        url
        title
        width
        height
        contentType
        description
      }
    }
  }
`

/** GraphQL selection for Contentful rich text fields (json + resolved link targets). */
export const RICH_TEXT_CONTENT_FIELDS = `
  json
  links {
    entries {
      block {
        ...RichTextEmbeddedEntry
      }
    }
    assets {
      block {
        sys { id }
        url
        title
        width
        height
        contentType
        description
      }
    }
  }
`
